import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type PostDeleteData = AnyObject;

export type PostDeleteResponse = PostDeleteData;

export interface PostDelete {
  id: string;
}

export const postDelete = (payload: PostDelete): Action<PostDelete> => ({
  type: actions.postDeleteTrigger.toString(),
  payload,
});

export const postDeleteClear = (): Action => ({
  type: actions.postDeleteClear.toString()
});

export const postDeleteErrorClear = (): Action => ({
  type: actions.postDeleteErrorReset.toString()
});

export function* postDeleteRequestSaga({ payload }: Action<PostDelete>) {
  yield put({
    type: actions.postDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.postDeleteError.toString(),
      payload: {
        message: 'PostDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}posts/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<PostDeleteData, PostDeleteResponse>(
    response,
    actions.postDeleteSuccess.toString(),
    actions.postDeleteError.toString(),
    false,
    (postDeleteData) => postDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.postDeleteTrigger.toString(),
    defaultProcessingSaga(
      postDeleteRequestSaga,
      {
        error: actions.postDeleteError.toString(),
        locationCancel: actions.postDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.postDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.postDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.postDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.postDeleteErrorReset.toString(),
    });
  });
}
